export const aggregtateList = [
  { code: 301, label: "Educação Infantil" },
  { code: 302, label: "Ensino Fundamental" },
  { code: 303, label: "Multi e correção de fluxo" },
  { code: 304, label: "Ensino Médio" },
  { code: 305, label: "Ensino Médio - Normal/ Magistério" },
  { code: 306, label: "Educação de Jovens e Adultos (EJA)" },
  { code: 308, label: "Educação Profissional Técnica de Nível Médio - Curso Técnico e FIC - Concomitante ou Subsequente" }
];
